import { useState, useEffect, useCallback, useContext } from 'react';
import {
	Container,
	Button,
	Pagination,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Tooltip,
	CircularProgress,
	Typography,
} from '@mui/material';
import Grid from '@mui/material/Grid';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import CategoryCard from '../../component/StyledComponents/CreateCards';
import CreateCategories from '../../forms/CreateCategories';
import {
	getAllCategory,
	addCategory,
	updateCategory,
	deleteCategory,
} from '../../../services/api/Category';
import type { Category } from '../../../types/cards';
import { GetAllMenuTypes } from '../../../services/api/Event';
import Toast from '../Toast/page';
import SearchBar from '../../component/custom/SearchBar';
import userContext from '../../../configs/context/context';

const Categories: React.FC = () => {
	const [categories, setCategories] = useState<Category[]>([]);
	const [openForm, setOpenForm] = useState(false);
	const [selectedCategory, setSelectedCategory] = useState<Category | null>(null);
	const [searchTerm, setSearchTerm] = useState('');
	const [loading, setLoading] = useState(true);
	const [currentPage, setCurrentPage] = useState(1);
	const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
	const [categoryToDelete, setCategoryToDelete] = useState<string | null>(null);
	const [loadingform, setLoadingform] = useState(false);
	const { setCategoryPopup } = useContext(userContext);
	const [deleting, setDeleting] = useState(false);
	const [menuTypes, setMenuTypes] = useState<string[]>([]);
	const [alertMessage, setAlertMessage] = useState<string | null>(null);
	const [alertSeverity, setAlertSeverity] = useState<'success' | 'error' | 'info' | 'warning'>(
		'success'
	);
	const itemsPerPage = 16;

	const fetchCategories = async () => {
		setLoading(true);
		try {
			const data = await getAllCategory();
			setCategories(data?.data?.categories.reverse() || []);

			if (data) {
				// setAlertMessage('Category Data fetch Successfully');
				// setAlertSeverity('success');
			}
		} catch (error) {
			console.error('Failed to fetch categories:', error);
			setAlertMessage('Failed to fetch categories:');
			setAlertSeverity('error');
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		fetchCategories();
	}, []);

	const handleAddCategory = () => {
		setSelectedCategory(null);
		setOpenForm(true);
		setCategoryPopup(true);
	};

	const handleEditCategory = (category: Category) => {
		setSelectedCategory(category);
		setOpenForm(true);
	};

	const fetchMenuTypes = useCallback(async () => {
		setLoading(true);
		try {
			const response = await GetAllMenuTypes();
			const data = response?.data?.menuTypes;
			setMenuTypes(data.map((item: any) => item.menuType) || []);
		} catch (error) {
			console.error('Failed to fetch menu types:', error);
		} finally {
			setLoading(false);
		}
	}, []);

	useEffect(() => {
		fetchMenuTypes();
	}, [fetchMenuTypes]);

	const handleDeleteClick = (categoryId: string) => {
		setCategoryToDelete(categoryId);
		setDeleteDialogOpen(true);
	};

	const handleCloseDeleteDialog = () => {
		setDeleteDialogOpen(false);
		setCategoryToDelete(null);
	};

	const handleConfirmDelete = async () => {
		if (!categoryToDelete) return;

		setDeleting(true);
		try {
			const response = await deleteCategory(categoryToDelete);
			setCategories(categories.filter((c) => c._id !== categoryToDelete));
			if (response.success) {
				setAlertMessage(response.data.message);
				setAlertSeverity('success');
			} else {
				setAlertMessage(response.data.message);
				setAlertSeverity('error');
			}

			// fetchCategories();
		} catch (error) {
			console.error('Failed to delete category:', error);
		} finally {
			setDeleting(false);
			handleCloseDeleteDialog();
		}
	};

	const handleSaveCategory = async (category: Category) => {
		const formData = new FormData();
		formData.append('name', category.name);
		formData.append('description', category.description);
		formData.append('slug', category.slug);

		// Properly handle tags array
		if (Array.isArray(category.tag)) {
			category.tag.forEach((tag) => formData.append('tag', tag));
		} else {
			formData.append('tag', category.tag || '');
		}

		if (category.categoryImage instanceof File) {
			formData.append('categoryImage', category.categoryImage);
		}

		try {
			if (selectedCategory) {
				setLoadingform(true);
				const response = await updateCategory(formData, selectedCategory._id.toString());
				const data = await response.json();
				console.log(data);
				if (data.success) {
					console.log(data, 'dddddddddd');
					setAlertMessage(data.message);
					setAlertSeverity('success');

					fetchCategories();
				} else {
					setAlertMessage(data.error);
					setAlertSeverity('error');
				}
			} else {
				setLoadingform(true);
				const response = await addCategory(formData);
				// const data = await response.json();
				console.log(response, 'DATAMMMM');
				fetchCategories();
				if (!response.isError) {
					setAlertMessage(response.data.message);
					setAlertSeverity('success');
					fetchCategories();
				} else {
					setAlertMessage(response.data.errors);
					setAlertSeverity('error');
				}
			}
			fetchCategories();
		} catch (error) {
			console.error('Failed to save category:', error);
		} finally {
			setLoadingform(false);
		}
		setOpenForm(false);
	};
	const handleToggleStatus = async (id: any, status: any) => {
		const formData = new FormData();
		formData.append('name', status.name);
		// const newStatus = { status: status === '1' ? '0' : '1' };
		formData.append('status', status.status == '1' ? '0' : '1');
		formData.append('description', status.description);
		formData.append('slug', status.slug);

		// // Properly handle tags array
		if (Array.isArray(status.tag)) {
			status.tag.forEach((tag: any) => formData.append('tag', tag));
		} else {
			formData.append('tag', status.tag || '');
		}

		if (status.categoryImage instanceof File) {
			formData.append('categoryImage', status.categoryImage);
		}
		// console.log(status, 'status>>>>>>>>>>>>');

		try {
			if (id) {
				setLoadingform(true);
				const response = await updateCategory(formData, id);
				const data = await response.json();
				console.log(data);
				if (data.success) {
					console.log(data, 'dddddddddd');
					setAlertMessage(data.message);
					setAlertSeverity('success');

					fetchCategories();
				} else {
					setAlertMessage(data.error);
					setAlertSeverity('error');
				}
			}
			// } else {
			// 	setLoadingform(true);
			// 	const response = await addCategory(formData);
			// 	// const data = await response.json();
			// 	console.log(response, 'DATAMMMM');
			// 	fetchCategories();
			// 	if (!response.isError) {
			// 		setAlertMessage(response.data.message);
			// 		setAlertSeverity('success');
			// 		fetchCategories();
			// 	} else {
			// 		setAlertMessage(response.data.errors);
			// 		setAlertSeverity('error');
			// 	}
			// }
			fetchCategories();
		} catch (error) {
			console.error('Failed to save category:', error);
		} finally {
			setLoadingform(false);
		}
		setOpenForm(false);
	};

	const handleCloseForm = () => {
		setOpenForm(false);
		setSelectedCategory(null);
	};

	// const filteredCategories = categories.filter((category) =>
	// 	category?.name?.toLowerCase()?.includes(searchTerm?.toLowerCase())
	// );
	const filteredCategories = categories.filter((category) =>
		category?.name?.toLowerCase()?.startsWith(searchTerm?.toLowerCase())
	);

	const totalPages = Math.ceil(filteredCategories.length / itemsPerPage);
	const paginatedCategories = filteredCategories.slice(
		(currentPage - 1) * itemsPerPage,
		currentPage * itemsPerPage
	);

	return (
		<>
			<Container maxWidth={false} sx={{ width: '100%', pt: 3, pb: 4 }}>
				<div
					style={{
						display: 'flex',
						justifyContent: 'space-between',
						alignItems: 'center',
						marginBottom: '16px',
					}}
				>
					<div>
						<SearchBar
							label={'Search Categories'}
							setSearchTerm={setSearchTerm}
							searchTerm={searchTerm}
						/>
					</div>
					<Tooltip title="Add new category" arrow>
						<Button
							variant="contained"
							color="primary"
							onClick={handleAddCategory}
							style={{ background: '#CA0005' }}
							startIcon={<AddIcon />}
						>
							Add Category
						</Button>
					</Tooltip>
				</div>

				<Typography
					sx={{
						// height: '70vh',
						display: 'flex',
						flexDirection: 'column',
						// overflowY: 'auto',
					}}
				>
					<Grid container spacing={3}>
						{loading ? (
							Array.from({ length: itemsPerPage }).map((_, index) => (
								<Grid item xs={12} sm={6} md={3} lg={2} key={index}>
									<div
										style={{
											backgroundColor: '#f5f5f5',
											height: '250px',
											borderRadius: '8px',
											display: 'flex',
											justifyContent: 'center',
											alignItems: 'center',
										}}
									>
										<CircularProgress size={24} />
									</div>
								</Grid>
							))
						) : paginatedCategories.length > 0 ? (
							paginatedCategories.map((category) => (
								<Grid item xs={12} sm={6} md={3} lg={3} xl={2} key={category._id}>
									<CategoryCard
										category={category}
										handelEdit={handleEditCategory}
										handleDelete={() => handleDeleteClick(category._id)}
										handleToggleStatus={handleToggleStatus}
									/>
								</Grid>
							))
						) : (
							<Grid item xs={12}>
								<Typography
									variant="body1"
									align="center"
									sx={{
										py: 4,
										fontFamily: 'Poppins',
										color: 'text.secondary',
									}}
								>
									No categories found. Try adding a new one!
								</Typography>
							</Grid>
						)}
					</Grid>
				</Typography>

				{totalPages > 1 && (
					<Grid container justifyContent="center" mt={4}>
						<Pagination
							count={totalPages}
							page={currentPage}
							onChange={(_, page) => setCurrentPage(page)}
							color="primary"
							shape="rounded"
						/>
					</Grid>
				)}

				<CreateCategories
					loading={loadingform}
					open={openForm}
					handleClose={handleCloseForm}
					handleSave={handleSaveCategory}
					category={selectedCategory}
					menuTypes={menuTypes}
				/>

				<Dialog
					open={deleteDialogOpen}
					onClose={handleCloseDeleteDialog}
					maxWidth="xs"
					fullWidth
					PaperProps={{
						style: {
							borderRadius: '12px',
						},
					}}
				>
					<DialogTitle sx={{ fontFamily: 'Poppins', fontWeight: 600 }}>
						Confirm Delete
					</DialogTitle>
					<DialogContent>
						<Typography variant="body1" sx={{ fontFamily: 'Poppins' }}>
							Are you sure you want to delete this category? This action cannot be
							undone.
						</Typography>
					</DialogContent>
					<DialogActions sx={{ px: 3, pb: 3 }}>
						<Button
							onClick={handleCloseDeleteDialog}
							color="primary"
							variant="outlined"
							disabled={deleting}
						>
							Cancel
						</Button>
						<Button
							onClick={handleConfirmDelete}
							color="error"
							variant="contained"
							disabled={deleting}
							startIcon={
								deleting ? (
									<CircularProgress size={20} color="inherit" />
								) : (
									<DeleteIcon />
								)
							}
							sx={{ minWidth: '100px' }}
						>
							{deleting ? 'Deleting...' : 'Delete'}
						</Button>
					</DialogActions>
				</Dialog>
			</Container>

			<Toast
				setAlertMessage={setAlertMessage}
				alertMessage={alertMessage}
				alertSeverity={alertSeverity}
			/>
		</>
	);
};

export default Categories;
